module.exports = __webpack_public_path__ + "static/media/011yhkgl.25c25557.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/011yhkgl.jpg
// module id = 632
// module chunks = 0 1